import { useMutateData } from "shared/services/base.service";
const BaseServicePath = process.env.REACT_APP_API_REPORT;

const ReportStockVisualizationApiService = () => ({});

export const {} = ReportStockVisualizationApiService();
